/**
 * Signals uit ruwe `applications.status` voor recruiter-UI (badges op Kanban / shortlist).
 */

/** Leesbare regel uit `applications.cv_snapshot.pipeline_meta` (Kanban / shortlist). */
export function formatPipelineInterviewHint(meta: Record<string, unknown> | undefined | null): string | null {
  if (!meta || typeof meta !== 'object') return null;
  const d = String((meta as any).gesprek_date || '').trim().slice(0, 10);
  const t1 = String((meta as any).gesprek_time_start || '').trim();
  const t2 = String((meta as any).gesprek_time_end || '').trim();
  if (!d && !t1 && !t2) return null;
  let line = '';
  if (d && /^\d{4}-\d{2}-\d{2}$/.test(d)) {
    line = new Date(`${d}T12:00:00`).toLocaleDateString('nl-NL', {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  }
  if (t1 && t2) line += (line ? ' · ' : '') + `${t1}–${t2}`;
  else if (t1) line += (line ? ' · ' : '') + t1;
  return line || null;
}

/** Korte labeltekst als de klant via het portaal akkoord heeft gegeven voor interview / vervolg. */
export function getClientPortalConsentBadgeLabel(rawStatus: string | null | undefined): string | null {
  const s = String(rawStatus || '').trim();
  if (!s) return null;
  if (/interview\s+gewenst/i.test(s) && /klantportaal/i.test(s)) return 'Klant akkoord → interview';
  if (/volgende\s+ronde/i.test(s) && /akkoord\s+klant/i.test(s)) return 'Klant akkoord → volgende ronde';
  if (/meer\s+informatie\s*\(klantportaal\)/i.test(s)) return 'Klant vraagt info';
  if (/on\s+hold\s*\(klantportaal\)/i.test(s)) return 'On hold (klant)';
  return null;
}

/** Korte labeltekst als de klant via het portaal heeft afgewezen (interview / traject). */
export function getClientPortalDeclineBadgeLabel(rawStatus: string | null | undefined): string | null {
  const s = String(rawStatus || '').trim();
  if (!s) return null;
  if (!/afgewezen\s+door\s+opdrachtgever/i.test(s)) return null;
  if (/na\s+gesprek/i.test(s)) return 'Klant: afwijzing na gesprek (portaal)';
  return 'Klant wees interview af (portaal)';
}
